import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/register/ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthPageShell"] */ "/opt/hotlistcasino/frontend/src/components/AuthPageShell.tsx");
